import { RUTAS_CONDICIONES, RUTAS_PRIVACIDAD } from './legalPaths'

export const getLocalizedPath = (currentPath: string, newLang: string) => {
  const pathWithoutLang = currentPath.split('/').slice(2).join('/')

  if (!pathWithoutLang) return `/${newLang}`

  const pathMappings: Record<string, Record<string, string>> = {
    // Política de privacidad
    privacidad: RUTAS_PRIVACIDAD,
    // Condiciones de contratación (campamentos y cumpleaños)
    condiciones: RUTAS_CONDICIONES,
    // About / Quiénes Somos
    about: {
      es: 'quienes-somos',
      en: 'about',
      pt: 'sobre-nos',
      fr: 'a-propos'
    },
    'quienes-somos': {
      es: 'quienes-somos',
      en: 'about',
      pt: 'sobre-nos',
      fr: 'a-propos'
    },
    'sobre-nosotros': {
      es: 'quienes-somos',
      en: 'about',
      pt: 'sobre-nos',
      fr: 'a-propos'
    },
    'sobre-nos': {
      es: 'quienes-somos',
      en: 'about',
      pt: 'sobre-nos',
      fr: 'a-propos'
    },
    'a-propos': {
      es: 'quienes-somos',
      en: 'about',
      pt: 'sobre-nos',
      fr: 'a-propos'
    },
    // Prices / Precios
    prices: {
      es: 'precios',
      en: 'prices',
      pt: 'precos',
      fr: 'tarifs'
    },
    precios: {
      es: 'precios',
      en: 'prices',
      pt: 'precos',
      fr: 'tarifs'
    },
    precos: {
      es: 'precios',
      en: 'prices',
      pt: 'precos',
      fr: 'tarifs'
    },
    tarifs: {
      es: 'precios',
      en: 'prices',
      pt: 'precos',
      fr: 'tarifs'
    },
    // Montessori
    montessori: {
      es: 'metodologia-montessori',
      en: 'montessori-education',
      pt: 'metodologia-montessori',
      fr: 'methode-montessori'
    },
    'colegio-montessori': {
      es: 'metodologia-montessori',
      en: 'montessori-education',
      pt: 'metodologia-montessori',
      fr: 'methode-montessori'
    },
    'montessori-school': {
      es: 'metodologia-montessori',
      en: 'montessori-education',
      pt: 'metodologia-montessori',
      fr: 'methode-montessori'
    },
    'metodologia-montessori': {
      es: 'metodologia-montessori',
      en: 'montessori-education',
      pt: 'metodologia-montessori',
      fr: 'methode-montessori'
    },
    'montessori-education': {
      es: 'metodologia-montessori',
      en: 'montessori-education',
      pt: 'metodologia-montessori',
      fr: 'methode-montessori'
    },
    'escola-montessori': {
      es: 'metodologia-montessori',
      en: 'montessori-education',
      pt: 'metodologia-montessori',
      fr: 'methode-montessori'
    },
    'ecole-montessori': {
      es: 'metodologia-montessori',
      en: 'montessori-education',
      pt: 'metodologia-montessori',
      fr: 'methode-montessori'
    },
    'methode-montessori': {
      es: 'metodologia-montessori',
      en: 'montessori-education',
      pt: 'metodologia-montessori',
      fr: 'methode-montessori'
    },
    // Trilingual
    'colegio-trilingue': {
      es: 'educacion-trilingue',
      en: 'trilingual-education',
      pt: 'educacao-trilingue',
      fr: 'education-trilingue'
    },
    'trilingual-school': {
      es: 'educacion-trilingue',
      en: 'trilingual-education',
      pt: 'educacao-trilingue',
      fr: 'education-trilingue'
    },
    'educacion-trilingue': {
      es: 'educacion-trilingue',
      en: 'trilingual-education',
      pt: 'educacao-trilingue',
      fr: 'education-trilingue'
    },
    'trilingual-education': {
      es: 'educacion-trilingue',
      en: 'trilingual-education',
      pt: 'educacao-trilingue',
      fr: 'education-trilingue'
    },
    'escola-trilingue': {
      es: 'educacion-trilingue',
      en: 'trilingual-education',
      pt: 'educacao-trilingue',
      fr: 'education-trilingue'
    },
    'educacao-trilingue': {
      es: 'educacion-trilingue',
      en: 'trilingual-education',
      pt: 'educacao-trilingue',
      fr: 'education-trilingue'
    },
    'ecole-trilingue': {
      es: 'educacion-trilingue',
      en: 'trilingual-education',
      pt: 'educacao-trilingue',
      fr: 'education-trilingue'
    },
    'education-trilingue': {
      es: 'educacion-trilingue',
      en: 'trilingual-education',
      pt: 'educacao-trilingue',
      fr: 'education-trilingue'
    },
    // School Calendar
    'calendario-escolar': {
      es: 'calendario-escolar',
      en: 'school-calendar',
      pt: 'calendario-escolar',
      fr: 'calendrier-scolaire'
    },
    'school-calendar': {
      es: 'calendario-escolar',
      en: 'school-calendar',
      pt: 'calendario-escolar',
      fr: 'calendrier-scolaire'
    },
    'calendrier-scolaire': {
      es: 'calendario-escolar',
      en: 'school-calendar',
      pt: 'calendario-escolar',
      fr: 'calendrier-scolaire'
    },
    // Extracurriculars
    extraescolares: {
      es: 'extraescolares',
      en: 'extracurriculars',
      pt: 'extracurriculares',
      fr: 'extrascolaires'
    },
    extracurriculars: {
      es: 'extraescolares',
      en: 'extracurriculars',
      pt: 'extracurriculares',
      fr: 'extrascolaires'
    },
    extracurriculares: {
      es: 'extraescolares',
      en: 'extracurriculars',
      pt: 'extracurriculares',
      fr: 'extrascolaires'
    },
    extrascolaires: {
      es: 'extraescolares',
      en: 'extracurriculars',
      pt: 'extracurriculares',
      fr: 'extrascolaires'
    },
    // Services
    servicios: {
      es: 'servicios',
      en: 'services',
      pt: 'servicos',
      fr: 'services'
    },
    services: {
      es: 'servicios',
      en: 'services',
      pt: 'servicos',
      fr: 'services'
    },
    servicos: {
      es: 'servicios',
      en: 'services',
      pt: 'servicos',
      fr: 'services'
    },
    // Admissions
    admisiones: {
      es: 'admisiones',
      en: 'admissions',
      pt: 'admissoes',
      fr: 'admissions'
    },
    admissions: {
      es: 'admisiones',
      en: 'admissions',
      pt: 'admissoes',
      fr: 'admissions'
    },
    admissoes: {
      es: 'admisiones',
      en: 'admissions',
      pt: 'admissoes',
      fr: 'admissions'
    },
    // Birthdays
    cumpleanos: {
      es: 'cumpleanos',
      en: 'birthdays',
      pt: 'aniversarios',
      fr: 'anniversaires'
    },
    birthdays: {
      es: 'cumpleanos',
      en: 'birthdays',
      pt: 'aniversarios',
      fr: 'anniversaires'
    },
    aniversarios: {
      es: 'cumpleanos',
      en: 'birthdays',
      pt: 'aniversarios',
      fr: 'anniversaires'
    },
    anniversaires: {
      es: 'cumpleanos',
      en: 'birthdays',
      pt: 'aniversarios',
      fr: 'anniversaires'
    },
    // Easter Camp
    'campamento-semana-santa': {
      es: 'campamento-semana-santa',
      en: 'easter-camp',
      pt: 'acampamento-pascoa',
      fr: 'camp-paques'
    },
    'easter-camp': {
      es: 'campamento-semana-santa',
      en: 'easter-camp',
      pt: 'acampamento-pascoa',
      fr: 'camp-paques'
    },
    'acampamento-pascoa': {
      es: 'campamento-semana-santa',
      en: 'easter-camp',
      pt: 'acampamento-pascoa',
      fr: 'camp-paques'
    },
    'camp-paques': {
      es: 'campamento-semana-santa',
      en: 'easter-camp',
      pt: 'acampamento-pascoa',
      fr: 'camp-paques'
    },
    // Summer Camp
    'campamento-verano': {
      es: 'campamento-verano',
      en: 'summer-camp',
      pt: 'acampamento-verao',
      fr: 'camp-ete'
    },
    'summer-camp': {
      es: 'campamento-verano',
      en: 'summer-camp',
      pt: 'acampamento-verao',
      fr: 'camp-ete'
    },
    'acampamento-verao': {
      es: 'campamento-verano',
      en: 'summer-camp',
      pt: 'acampamento-verao',
      fr: 'camp-ete'
    },
    'camp-ete': {
      es: 'campamento-verano',
      en: 'summer-camp',
      pt: 'acampamento-verao',
      fr: 'camp-ete'
    },
    // Summer Camp Confirmation
    'confirmacion-campamento-verano': {
      es: 'confirmacion-campamento-verano',
      en: 'summer-camp-confirmation',
      pt: 'confirmacao-acampamento-verao',
      fr: 'confirmation-camp-ete'
    },
    'summer-camp-confirmation': {
      es: 'confirmacion-campamento-verano',
      en: 'summer-camp-confirmation',
      pt: 'confirmacao-acampamento-verao',
      fr: 'confirmation-camp-ete'
    },
    'confirmacao-acampamento-verao': {
      es: 'confirmacion-campamento-verano',
      en: 'summer-camp-confirmation',
      pt: 'confirmacao-acampamento-verao',
      fr: 'confirmation-camp-ete'
    },
    'confirmation-camp-ete': {
      es: 'confirmacion-campamento-verano',
      en: 'summer-camp-confirmation',
      pt: 'confirmacao-acampamento-verao',
      fr: 'confirmation-camp-ete'
    },
    // Christmas Camp
    'campamento-navidad': {
      es: 'campamento-navidad',
      en: 'christmas-camp',
      pt: 'acampamento-natal',
      fr: 'camp-noel'
    },
    'christmas-camp': {
      es: 'campamento-navidad',
      en: 'christmas-camp',
      pt: 'acampamento-natal',
      fr: 'camp-noel'
    },
    'acampamento-natal': {
      es: 'campamento-navidad',
      en: 'christmas-camp',
      pt: 'acampamento-natal',
      fr: 'camp-noel'
    },
    'camp-noel': {
      es: 'campamento-navidad',
      en: 'christmas-camp',
      pt: 'acampamento-natal',
      fr: 'camp-noel'
    },
    // Courses
    cursos: {
      es: 'cursos',
      en: 'courses',
      pt: 'cursos',
      fr: 'cours'
    },
    courses: {
      es: 'cursos',
      en: 'courses',
      pt: 'cursos',
      fr: 'cours'
    },
    cours: {
      es: 'cursos',
      en: 'courses',
      pt: 'cursos',
      fr: 'cours'
    },
    // Feedback
    'quejas-sugerencias': {
      es: 'quejas-sugerencias',
      en: 'feedback',
      pt: 'reclamacoes-sugestoes',
      fr: 'plaintes-suggestions'
    },
    feedback: {
      es: 'quejas-sugerencias',
      en: 'feedback',
      pt: 'reclamacoes-sugestoes',
      fr: 'plaintes-suggestions'
    },
    'reclamacoes-sugestoes': {
      es: 'quejas-sugerencias',
      en: 'feedback',
      pt: 'reclamacoes-sugestoes',
      fr: 'plaintes-suggestions'
    },
    'plaintes-suggestions': {
      es: 'quejas-sugerencias',
      en: 'feedback',
      pt: 'reclamacoes-sugestoes',
      fr: 'plaintes-suggestions'
    },
    // Open House Registration
    'inscripcion-puertas-abiertas': {
      es: 'inscripcion-puertas-abiertas',
      en: 'open-house-registration',
      pt: 'inscricao-portas-abertas',
      fr: 'inscription-portes-ouvertes'
    },
    'open-house-registration': {
      es: 'inscripcion-puertas-abiertas',
      en: 'open-house-registration',
      pt: 'inscricao-portas-abertas',
      fr: 'inscription-portes-ouvertes'
    },
    'inscricao-portas-abertas': {
      es: 'inscripcion-puertas-abiertas',
      en: 'open-house-registration',
      pt: 'inscricao-portas-abertas',
      fr: 'inscription-portes-ouvertes'
    },
    'inscription-portes-ouvertes': {
      es: 'inscripcion-puertas-abiertas',
      en: 'open-house-registration',
      pt: 'inscricao-portas-abertas',
      fr: 'inscription-portes-ouvertes'
    },
    // Renewal
    'renovacion': {
      es: 'renovacion',
      en: 'renewal',
      pt: 'renovacao',
      fr: 'renouvellement'
    },
    'renewal': {
      es: 'renovacion',
      en: 'renewal',
      pt: 'renovacao',
      fr: 'renouvellement'
    },
    'renovacao': {
      es: 'renovacion',
      en: 'renewal',
      pt: 'renovacao',
      fr: 'renouvellement'
    },
    'renouvellement': {
      es: 'renovacion',
      en: 'renewal',
      pt: 'renovacao',
      fr: 'renouvellement'
    },
    // Renewal Confirmation
    'confirmacion-renovacion': {
      es: 'confirmacion-renovacion',
      en: 'renewal-confirmation',
      pt: 'confirmacao-renovacao',
      fr: 'confirmation-renouvellement'
    },
    'renewal-confirmation': {
      es: 'confirmacion-renovacion',
      en: 'renewal-confirmation',
      pt: 'confirmacao-renovacao',
      fr: 'confirmation-renouvellement'
    },
    'confirmacao-renovacao': {
      es: 'confirmacion-renovacion',
      en: 'renewal-confirmation',
      pt: 'confirmacao-renovacao',
      fr: 'confirmation-renouvellement'
    },
    'confirmation-renouvellement': {
      es: 'confirmacion-renovacion',
      en: 'renewal-confirmation',
      pt: 'confirmacao-renovacao',
      fr: 'confirmation-renouvellement'
    },
    // Enrollment Confirmation
    'confirmacion-preinscripcion': {
      es: 'confirmacion-preinscripcion',
      en: 'enrollment-confirmation',
      pt: 'confirmacao-preinscricao',
      fr: 'confirmation-preinscription'
    },
    'enrollment-confirmation': {
      es: 'confirmacion-preinscripcion',
      en: 'enrollment-confirmation',
      pt: 'confirmacao-preinscricao',
      fr: 'confirmation-preinscription'
    },
    'confirmacao-preinscricao': {
      es: 'confirmacion-preinscripcion',
      en: 'enrollment-confirmation',
      pt: 'confirmacao-preinscricao',
      fr: 'confirmation-preinscription'
    },
    'confirmation-preinscription': {
      es: 'confirmacion-preinscripcion',
      en: 'enrollment-confirmation',
      pt: 'confirmacao-preinscricao',
      fr: 'confirmation-preinscription'
    },
  }

  for (const [pageKey, translations] of Object.entries(pathMappings)) {
    if (Object.values(translations).includes(pathWithoutLang)) {
      return `/${newLang}/${pathMappings[pageKey][newLang]}`
    }
  }

  // Unmapped path (e.g., SEO landing pages): preserve the slug so the user stays on the same page
  // in the new language rather than being redirected to the homepage.
  return `/${newLang}/${pathWithoutLang}`
}
